// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error:
import SimpleBar from "simplebar-react";
import { styled } from "@mui/material/styles";

export const Scrollbar = styled(SimpleBar)``;
